"use strict";

import axios from "@/plugins/axios";

export const workshop = {
  namespaced: true,
  state: {
    currentWorkshop: {},
    times_of_currentWorkshop: [],
    data: [],
    trainers: []
  },
  getters: {
    getWorkshops: state => state.data,
    getTrainers: state => state.trainers,
    getWorkshop: state => state.currentWorkshop,
    getTimes: state => state.times_of_currentWorkshop
  },
  mutations: {
    UPDATE_DATA: (state, payload) => (state.data = payload),
    UPDATE_TRAINERS: (state, payload) => (state.trainers = payload),
    SET_CURRENT_WORKSHOP: (state, payload) => (state.currentWorkshop = payload),
    SET_TIMES_OF_CURRENT_WORKSHOP: (state, payload) => (state.times_of_currentWorkshop = payload),
  },
  actions: {
    async getWorkshop({ commit, state }, payload) {
      try {
        commit('SET_CURRENT_WORKSHOP', state.data.filter(couse => couse._id === payload)[0]);
      } catch (error) {
        return error;
      }
    },
    async makePublic({ commit }, payload) {
      try {
        let res = (await axios.get(`/api/workshop/publish/${payload}`,)).data
        if (res.success) commit('SET_CURRENT_WORKSHOP', res.data)
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        return error;
      }
    },
    async getTimes({ commit }, payload) {
      try {
        let res = (await axios.get(`/api/times/${payload}`)).data
        if (res.success) commit('SET_TIMES_OF_CURRENT_WORKSHOP', res.data);
      } catch (error) {

        return error;
      }
    },
    async getWorkshopById({ commit }, payload) {
      try {
        let res = (await axios.get(`/api/workshop/${payload}`)).data
        if (res.success) commit('SET_CURRENT_WORKSHOP', res.data)
      } catch (error) {
        return error
      }
    },
    async deleteWorkshop({ state }, payload) {
      try {
        let res = (await axios.delete(`api/workshop/${payload.id}`)).data
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        state.data = state.data.filter(workshop => workshop._id !== payload.id);
      } catch (e) {
        window.flash({ type: "error", msg: "Da ist etwas schief gelaufen. Das Problem wurde gemeldet um sich darum zu kümmern." })
      }
    },

    async getWorkshops({ commit }) {
      try {
        let data = (await axios.get("/api/workshops")).data;


        commit("UPDATE_DATA", data.data);
      } catch (error) {
        return error

      }
    },
    async uploadImage({ state }, payload) {
      try {

        let res = (
          await axios.post("api/workshop/profileImage", payload, {
            headers: { "Content-Type": "multipart/f orm-data" },
          })
        ).data;

        if (res.success) {
          state.data.filter((workshop, index) => {
            if (workshop._id === res.data._id) state.data[index].photoURL = res.data.photoURL;
          })
          state.currentWorkshop.photoURL = res.data.photoURL;
        }
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }
    },

    async blockWorkshop({ state }, payload) {
      try {
        let res = (await axios.get(`/api/workshop/block/${payload}`)).data;
        if (res.success) state.data.filter((workshop, index) => {
          if (workshop._id === payload) {

            state.data[index].blocked = !state.data[index].blocked;
            state.data[index].blocked_by = res.data.blocked_by;
          }
        })
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        return error
      }
    },

    async updateWorkshop({ state }, payload) {
      try {
        let res = (await axios.post("api/workshop", payload)).data;
        if (res.success) {
          state.data.map(workshop =>
            workshop.title === res.data.title ? res.data : workshop
          )
        }
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }
    },
    async createNewTrainer({ state }, payload) {
      try {
        let res = (await axios.post('api/trainer', payload)).data

        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if (res.success) { state.data = state.data.unshift(res.data); return true; }
      } catch (e) {

        window.flash({ type: "error", msg: "Da ist etwas schief gelaufen. Das Problem wurde gemeldet um sich darum zu kümmern." })
      }
    },
    async createNewWorkshop({ state }, payload) {
      try {
        let res = (await axios.post('api/workshops', payload)).data

        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if (res.success) { state.data = state.data.unshift(res.data); return true; }
      } catch (e) {

        window.flash({ type: "error", msg: "Da ist etwas schief gelaufen. Das Problem wurde gemeldet um sich darum zu kümmern." })
      }
    },
    async getTimesforWorkshop({ state }, payload) {
      try {


        let res = (await axios.get(`/api/times/${payload._id}`)).data;

        if (res.success) {
          state.data.forEach((item, i) => {
            /* eslint-disable-next-line no-unused-vars */
            Object.entries(item).map(([key, val]) => {
              val = JSON.parse(JSON.stringify(val))

              if (key === '_id' && val === payload._id) {
                state.data[i].times = res.data;
              }
            })
          });
        }
      } catch (error) {

        return error
      }
    },
    async addTime({ state }, payload) {
      try {
        let res = (await axios.post('api/times', payload)).data

        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if (res.success) {
          state.times_of_currentWorkshop.push(res.data);
          return true;
        }
      } catch (e) {

        window.flash({ type: "error", msg: "Da ist etwas schief gelaufen. Das Problem wurde gemeldet um sich darum zu kümmern." })
      }
    },
    async getTrainers({ commit }) {
      try {
        let data = (await axios.get("/api/trainers")).data;

        commit("UPDATE_TRAINERS", data.data);
      } catch (error) {

        return error
      }
    }
  }
};
